import React from "react";
import HusklyLogo from "./HusklyLogo";
import AppDesktopNav from "./AppDesktopNav";
import ThemeSelector from "./ThemeSelector";
import AppDropdownMenu from "./AppDropdownMenu";

type SelectedItem =
  "dashboard" | "transactions" | "metrics" | "alerts" | "settings" | undefined;

interface HeaderProps {
  compact?: boolean;
  currentUser?: boolean;
  admin?: boolean;
  showNav?: boolean;
  selectedItem?: SelectedItem;
  formAuthenticityToken?: string;
  title?: string;
}

const Header = ({
  compact = false,
  currentUser = false,
  admin = false,
  showNav = false,
  selectedItem,
  formAuthenticityToken = "",
  title,
}: HeaderProps) => {
  return (
    <div>
      <div
        className={`${
          compact ? "p-1 md:py-2 md:px-4" : "p-4 md:py-4 md:px-8"
        } dark:bg-gray-700 flex flex-wrap justify-between items-center`}
      >
        <div className="mb-4 flex items-center justify-center">
          <a href="/">
            <div
              className={`fill-black ${compact ? "w-10 h-10" : "w-12 h-12"}`}
            >
              <HusklyLogo />
            </div>
          </a>
        </div>
        {showNav && <AppDesktopNav selectedItem={selectedItem as any} />}
        <div className="flex items-center dark:text-slate-300 text-slate-900">
          <ThemeSelector />
          {currentUser && (
            <AppDropdownMenu
              formAuthenticityToken={formAuthenticityToken}
              selectedItem={selectedItem as any}
              admin={admin}
            />
          )}
        </div>
      </div>
      {!compact && (
        <div className="p-8 flex flex-wrap justify-between items-end border-b-2 border-zinc-200 dark:border-gray-800 dark:bg-gray-700">
          <h1 className="font-semibold text-4xl dark:text-gray-300">{title}</h1>
        </div>
      )}
    </div>
  );
};

export default Header;
